<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-03-08 16:52:05
 * @LastEditors: may.li
 * @LastEditTime: 2023-03-22 14:53:47
-->
<template>
	<div class="page page_fans page_adress">
		<van-search v-model="keyword" shape="round" show-action placeholder="请输入业务员电话">
			<template #action>
				<div @click="searchFun" class="shaixuan-btn">筛选</div>
			</template>
		</van-search>
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
			<div class="list">
				<div class="item" v-for="(item,index) in dataList" :key="index" @click="toSaomaLog(item)">
					<div class="item_l">
						<div class="user_name slh_s">业务员：{{ item.name }}</div>
						<div class="user_name user-phone">手机号：{{ item.phone }}</div>
					</div>
					<div class="item_r action-wrap">
						<div :class="item.status == 1 ? 'action cancle-action' : 'action'" @click.stop="changeStatus(item,index)">{{ item.status == 1 ?  '禁用' : '恢复' }}</div>
					</div>
				</div>
			</div>
		</van-list>
		<div class="action-bottom">
			<div class="add-action" @click="showAdd=true">添加业务员</div>
		</div>
		<van-overlay z-index="20" :show="showAdd">
			<div class="sec-confirm">
				<div class="confirm-name">添加业务员</div>
				<div class="beizhu-wrap">
					<span class="beizhu-text">姓名：</span>
					<van-field v-model="name" :border="false" placeholder="请输入" />
				</div>
				<div class="beizhu-wrap">
					<span class="beizhu-text">手机号：</span>
					<van-field v-model="phone" :border="false" placeholder="请输入" />
				</div>
				<div class="confirm-actions">
					<div class="confirm-btn ac-cancle" @click="cancelAdd">取消</div>
					<div class="confirm-btn" @click="confirmAdd">确认</div>
				</div>
			</div>
		</van-overlay>
	</div>
</template>
<script>
export default {
	data(){
		return{
			token: null,
			keyword: null,
			first_agent_uuid: null,
			page: 1,
			size: 10,
			dataList: [],
			loading: false,
			finished: false,
			showAdd: false,
			name: null,
			phone: null,
			submitLoading: false
		}
	},
	created(){
		this.token = this.$store.getters.token;
		this.first_agent_uuid = this.$route.query.first_agent_uuid;
	},
	watch: {
		'keyword': function(val){
			if(!val){
				this.page = 1;
				this.loading = true;
				this.finished = false;
				this.dataList = [];
				this.getData();
			}
		}
	},
	methods: {
		/**
		 * @name: 确认添加
		 * @return {*}
		 * @desc: 
		 */		
		confirmAdd(){
			let that = this;
			if(this.submitLoading){
				return;
			};
			if(!this.name){
				this.$toast("请填写业务员姓名");
				return;
			};
			if(!this.phone){
				this.$toast("请填写业务员电话");
				return;
			}else if(!(/^1[3456789]\d{9}$/.test(that.phone))){
				this.$toast('请输入合法的手机号');
                return;
			}
			let params = {
				token: this.token,
				first_agent_uuid: this.first_agent_uuid,
				name: this.name,
				phone: this.phone
			};
			this.submitLoading = true;
			this.$api.agent.createsaleman(params).then(res=>{
				if(res.code == 200){
					this.$toast(res.message);
					this.name = null;
					this.phone = null;
					this.showAdd = false;
					this.submitLoading = false;
					this.page = 1;
					this.loading = true;
					this.finished = false;
					this.dataList = [];
					this.getData();
				}else{
					this.$toast(res.message);
					this.submitLoading = false;
				}
			})
		},
		/**
		 * @name: 取消添加
		 * @return {*}
		 * @desc: 
		 */		
		cancelAdd(){
			this.name = null;
			this.phone = null;
			this.showAdd = false;
		},
		/**
		 * @name: 跳转业务员的扫码记录
		 * @param {*} item
		 * @return {*}
		 * @desc: 
		 */		
		toSaomaLog(item){
			this.$router.push({
				path: '/agent/salesman/saomalog',
				query: {
					uuid: item.uuid
				}
			})
		},
		/**
		 * @name: 搜索
		 * @return {*}
		 * @desc: 
		 */		
		searchFun(){
			if(!this.keyword){
				this.$toast('请输入业务员电话');
				return;
			}else if(!(/^1[23456789]\d{9}$/.test(this.keyword))){
				this.$toast('请检查业务员电话是否正确');
				return;
			};
			this.page = 1;
			this.loading = true;
			this.finished = false;
			this.dataList = [];
			this.getData();
		},
		/**
		 * @name: 改变业务员的状态
		 * @param {*} item
		 * @param {*} index
		 * @return {*}
		 * @desc: 
		 */		
		changeStatus(item,index){
			let oldStatus = item.status;
			let params = {
				token: this.token,
				id: item.id,
				status: oldStatus == 1 ? 2 : 1
			};
			this.$api.salesman.status(params).then(res=>{
				if(res.code == 200){
					item.status = oldStatus == 1 ? 2 : 1;
					this.$set(this.dataList,item,index);
					this.$toast(res.message);
				}else{
					this.$toast(res.message);
				}
			})
		},
		/**
		 * @name: 获取业务员
		 * @return {*}
		 * @desc: 
		 */		
		getData(){
			let params = {
				token: this.token,
				page: this.page,
				size: this.size,
				first_agent_uuid: this.first_agent_uuid
			};
			if(this.keyword){
				params.keyword = this.keyword;
			};
			this.$api.agent.salesman(params).then(res=>{
				if(res.code == 200){
					let list = res.result;
					if(list && list.length){
						for(let i in list){
							this.dataList.push(list[i])
						};
						if(list.length < this.size){
							this.finished = true;
						}else{
							this.page++;
							this.loading = false;
						}
					}else{
						this.finished = true;
					}
				}else{
					this.finished = true;
				}
			})
		}
	},
}
</script>
<style scoped>
	.page_fans {
		padding-bottom: 1.6rem;
	}
	.page_fans .list {
		margin-bottom: 0;
		padding-bottom: 0.4rem;
	}
	.page_fans .list .item{
		height: auto;
		padding: .4rem .53rem .4rem 0;
	}
	.page_fans .list .item_l{
		flex-direction: column;
		align-items: flex-start;
	}
	.page_fans .list .item .user-phone{
		padding-top: .2rem;
	}
	.page_fans .list .item .user_name{
		padding-left: 0;
	}
	.page_fans .list .item .action{
		color: rgba(211, 68, 68, 1);
		border-color: rgba(211, 68, 68, 1);
	}
	.page_fans .list .item .action.cancle-action{
		background: rgba(244, 244, 244, 1);
		color: rgba(0, 0, 0, 0.54);
		border-color: rgba(0, 0, 0, 0.54);
	}
	.page_fans .list .item .action:last-child{
		margin-right: 0;
	}
	.shaixuan-btn{
		font-weight: bold;
	}
	.action-bottom{
		position: fixed;
		bottom: 0;
		width: 100%;
		padding: 0.24rem 0;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0rem 0.04rem 0.16rem 0rem rgb(0,0,0,.05);
	}
	.action-bottom .add-action{
		width: 8.94rem;
		height: 0.93rem;
		line-height: 0.93rem;
		text-align: center;
		margin: 0 auto;
		background: linear-gradient( 90deg, rgba(223, 52, 52, 1), rgba(255, 95, 52, 1));
		border-radius: 0.47rem;
		font-size: 0.4rem;
		color: rgba(255, 255, 255, 1);
	}
	.sec-confirm{
		width: 8rem;
		border-radius: .4rem;
		background: #ffffff;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		padding: .4rem;
	}
	.sec-confirm .confirm-name{
		font-size: .4rem;
		text-align: center;
	}
	.sec-confirm .confirm-actions{
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-top: 0.4rem;
		font-size: .38rem;
	}
	.sec-confirm .confirm-actions .confirm-btn{
		width: 2.67rem;
		height: 0.93rem;
		border-radius: 0.47rem;
		font-size: 0.4rem;
		text-align: center;
		line-height: 0.93rem;
		color: rgba(255, 255, 255, 1);
		background: linear-gradient( 90deg, rgba(223, 52, 52, 1), rgba(255, 95, 52, 1));
	}
	.sec-confirm .confirm-actions .confirm-btn.ac-cancle{
		background: rgba(0,0,0,.2);
	}
	.sec-confirm .beizhu-wrap{
		display: flex;
    	align-items: flex-end;
		height: 0.77rem;
		line-height: 0.77rem;
		margin-top: 0.2rem;
	}
	.sec-confirm .beizhu-wrap .van-cell{
		width: auto;
		padding: 0;
		line-height: unset;
		border-bottom: 0.0134rem solid rgba(0,0,0,.1);
	}
</style>